import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { GET_USER_RATING_BY_ID } from '../../../../../../graphql/Catalog/UsersRating/usersRating'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import moment from 'moment'
import { Loader } from 'lucide-react'

const feedBackPositivesMessages = [
  'Excelente trabajo, sigue así.',
  'Superaste las expectativas, ¡felicidades!',
  'Tu compromiso es evidente y muy valorado.',
  'Has demostrado un gran nivel de responsabilidad.',
  'Una mejora notable desde la última vez.',
  'Muy buena actitud ante los retos.',
  'Se nota que te estás esforzando.',
  'Mantuviste una comunicación clara y efectiva.',
  'Mostraste mucha iniciativa, ¡bien hecho!',
  'Muy buena organización y manejo del tiempo.',
  'Aportaste ideas muy valiosas.',
  'Has sido un excelente compañero de equipo.',
  'Cumpliste con todo en tiempo y forma.',
  'Tu atención al detalle marcó la diferencia.',
  'Respondiste bien ante la presión.',
  'Demostraste liderazgo en el proyecto.',
  'Gran disposición para colaborar.',
  'Tu trabajo inspira confianza.',
  'Has sido constante y disciplinado.',
  'El resultado fue de muy alta calidad.',
]

const feedBackNegativesMessages = [
  'Hay áreas para mejorar, pero vas por buen camino.',
  'Con un poco más de enfoque, lograrás grandes cosas.',
  'Se nota el esfuerzo, aunque podemos pulir algunos detalles.',
  'Aún hay margen de mejora, pero estás avanzando.',
  'Algunos errores se pueden corregir fácilmente.',
  'El resultado no fue el esperado, pero la intención es clara.',
  'Con más práctica, tu desempeño mejorará notablemente.',
  'Un pequeño ajuste marcaría una gran diferencia.',
  'Agradezco tu trabajo; solo falta un poco más de consistencia.',
  'Buen intento, solo hay que revisar ciertos aspectos clave.',
  'Te animo a dedicar más tiempo en ciertas áreas.',
  'El objetivo no se cumplió del todo, pero estás muy cerca.',
  'Te falta poco para alcanzar un excelente nivel.',
  'Se requiere más claridad, pero tienes buena base.',
  'Con más organización, el resultado será excelente.',
  'Es un buen inicio; sigamos mejorando.',
  'Estás aprendiendo rápido, aunque aún hay retos por superar.',
  'Reconozco tu esfuerzo; enfoquémonos en mejorar el proceso.',
  'Algunas decisiones podrían mejorarse, pero la dirección es buena.',
  'Un pequeño paso atrás para dar uno más firme adelante.',
  'No te desanimes, cada error es una oportunidad de aprendizaje.',
]

const DetailsRatings = ({ ratingId, setCloseModal }) => {
  const [infoRating, setInfoRating] = useState(false)
  const { loading, error, data } = useQuery(GET_USER_RATING_BY_ID, {
    variables: {
      id: parseInt(ratingId),
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (!ratingId) return
      if (loading) return
      if (error) throw new Error(error.message)

      const ratingInfo = data.getUserRatingById
      setInfoRating(ratingInfo)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  return (
    <>
      {!infoRating && loading && (
        <div className="d-flex align-items-center justify-content-center">
          <Loader />
        </div>
      )}
      {infoRating && !loading && (
        <>
          <div className="row p-3">
            <div
              className="col-lg-12"
              style={{
                backgroundColor:
                  infoRating.feedback_type === 'positive'
                    ? '#d4edda'
                    : '#f8d7da',
                borderRadius: '5px',
                marginTop: '10px',
                paddingTop: '10px',
                // padding: '',
                marginBottom: '10px',
                maxWidth: '90%',
                marginLeft: 'auto',
                marginRight: 'auto',
                color:
                  infoRating.feedback_type === 'positive'
                    ? '#28a745'
                    : '#dc3545',
              }}
            >
              <h3 className="text-center">
                <i
                  className={`fas fa-${
                    infoRating.feedback_type === 'positive'
                      ? 'thumbs-up'
                      : 'thumbs-down'
                  } mr-2`}
                  style={{
                    color:
                      infoRating.feedback_type === 'positive'
                        ? '#28a745'
                        : '#dc3545',
                  }}
                ></i>
                {infoRating.feedback_type_label}
              </h3>
              {/* <p className="text-center lead">
              {infoRating.feedback_type === 'positive'
                ? feedBackPositivesMessages[
                    Math.floor(Math.random() * feedBackPositivesMessages.length)
                  ]
                : feedBackNegativesMessages[
                    Math.floor(Math.random() * feedBackNegativesMessages.length)
                  ]}
            </p> */}
            </div>
            <div className="col-lg-6 mt-2">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-secondary">
                    <i className="fas fa-user mr-2"></i>
                    <strong>Calificador</strong>
                  </h5>
                  <p className="card-text lead">
                    {infoRating ? infoRating.userRated.name : 'N/A'}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-2">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-secondary">
                    <i className="fas fa-calendar mr-2"></i>
                    <strong>Fecha</strong>
                  </h5>
                  <p className="card-text lead">
                    {infoRating
                      ? moment(infoRating.created_date).format(
                          'dddd D[,] MMMM YYYY'
                        )
                      : 'N/A'}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-2">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-secondary">
                    <i class="fas fa-comment mr-2"></i>
                    <strong>Comentarios</strong>
                  </h5>
                  <p className="card-text lead">
                    {infoRating ? infoRating.comment : 'N/A'}
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="col-12 col-lg-12 p-3">
            <span className="title-details">Comentarios</span>
            <br />
            <span className="content-details">
              {infoRating ? infoRating.comment : 'N/A'}
            </span>
          </div> */}
          </div>
        </>
      )}
    </>
  )
}

export default DetailsRatings
